<div *ngIf="getMessage">
  <div class="terms-and-conditions-modal p-3 p-4 rounded-2">
    <div
      class="terms-and-conditions-modal__head d-flex justify-content-between align-items-center"
    >
      <p class="f-size-14">წესები და პირობები</p>
      <button type="button" class="button close" (click)="onCloseModal()">
        <img src="/assets/images/close.svg" alt="X" />
      </button>
    </div>
    <div class="terms-and-conditions-modal__body">
      <article class="pt-4" custom-scrollbar>
        <div [innerHtml]="getMessage"></div>
      </article>
    </div>
    <div class="d-flex justify-content-between mt-5">
      <button class="btn btn-secondary" (click)="onDeclineTAC()">
        არ ვეთანხმები
      </button>
      <button class="btn btn-primary bg-vibrant-blue" (click)="onAcceptTAC()">
        ვეთანხმები
      </button>
    </div>
  </div>
  <div class="terms-and-conditions-modal__bg" (click)="onCloseModal()"></div>
</div>
